export type CoincidenciaAutomatica = {
  registroId: string;
  registroFechaDia: string;
  registroMonto: number;
  registroIdsucursal?: number | null;
  registroSucursalNombre?: string | null;
  registroFechaHoraAperturaTurno?: string | null;
  registroFechaCierre?: string | null;
  registroFechaApertura?: string | null;
  registroTurno?: string | null;
  registroIdTurno?: number | null;
  registroIdControlCaja?: number | null;
  registroCajeroNombre?: string | null;
  registroCajeroApellido?: string | null;
  registroNumeroMovimiento?: string | null;
  registroFechaTexto?: string | null;
  registroInicioTurnoTexto?: string | null;
  registroFinTurnoTexto?: string | null;
  registroFormaPago?: string | null;
  movimientoId: string;
  movimientoFechaHora?: string | null;
  movimientoSucursal?: string | null;
  movimientoTipoPago?: string | null;
  movimientoImporteConDelivery?: number | null;
  movimientoImporteOrden?: number | null;
  movimientoNroTransaccion?: string | null;
  movimientoNroOrden?: string | null;
  movimientoIdIntegracion?: string | null;
  movimientoEstado?: string | null;
  conciliacionId?: number | null;
  conciliacionUsuarioId?: number | null;
  conciliacionUsuarioNombre?: string | null;
  conciliacionFecha?: string | null;
  conciliacionEstado?: string | null;
  conciliacionOrigen?: string | null;
};

export type CoincidenciaPendiente = {
  id?: string;
  registroId?: string;
  registroIdsucursal?: number | null;
  movimientoId?: string;
  fecha?: string;
  fechaDia?: string;
  movimientoFechaHora?: string;
  sucursal?: string;
  movimientoSucursal?: string;
  registroSucursalNombre?: string;
  monto?: number | string | null;
  movimientoImporteConDelivery?: number | string | null;
  movimientoImporteOrden?: number | string | null;
  formaPago?: string | null;
  movimientoTipoPago?: string | null;
  observacion?: string | null;
  detalle?: string | null;
  registroTurno?: string | null;
  registroIdTurno?: number | null;
  registroIdControlCaja?: number | null;
  registroNumeroMovimiento?: string | null;
  registroCajeroNombre?: string | null;
  registroCajeroApellido?: string | null;
  movimientoNroTransaccion?: string | null;
  movimientoNroOrden?: string | null;
  movimientoEstado?: string | null;
  movimientoTipoEntrega?: string | null;
};

export type CoincidenciaAutomaticaRespuesta = {
  ok: boolean;
  registros: CoincidenciaAutomatica[];
  sinCoincidenciasMonchis?: CoincidenciaPendiente[];
  sinCoincidenciasPedidosYa?: CoincidenciaPendiente[];
  sugeridos?: CoincidenciaAutomatica[];
  totalRegistradosSistema?: number;
  totalRegistradosMonchis?: number;
};

export type ConciliacionAutomaticaAplicarResponse = {
  ok: boolean;
  total: number;
  guardadas: number;
  nuevas: number;
  actualizadas: number;
  omitidas: number;
  conflictos?: string[];
};

export type RegistroPendienteConciliacion = {
  id: string;
  registroId?: string | null;
  registroIdsucursal?: number | null;
  movimientoId?: string | null;
  fecha?: string | null;
  sucursal?: string | null;
  movimientoSucursal?: string | null;
  monto?: number | null;
  formaPago?: string | null;
  observacion?: string | null;
  tipo?: "sistema" | "monchis";
  registroTurno?: string | null;
  registroIdTurno?: number | null;
  registroIdControlCaja?: number | null;
  registroNumeroMovimiento?: string | null;
  registroCajero?: string | null;
  movimientoTipoPago?: string | null;
  movimientoNroTransaccion?: string | null;
  movimientoNroOrden?: string | null;
  movimientoEstado?: string | null;
  movimientoTipoEntrega?: string | null;
  movimientoFechaHora?: string | null;
  movimientoImporteConDelivery?: number | null;
  movimientoImporteOrden?: number | null;
};

export type SucursalSistemaOption = {
  idsucursal: number;
  sucursalNombre: string;
  monchisSucursales: string[];
};

export type ResumenFila = {
  clave: string;
  fechaClave: string | null;
  fechaTexto: string;
  sistema: {
    conciliados: { tickets: number; monto: number };
    pendientes: { tickets: number; monto: number };
  };
  monchis: {
    conciliados: { tickets: number; monto: number };
    pendientes: { tickets: number; monto: number };
  };
  sugeridos: { tickets: number; monto: number };
};

export const construirFechaIso = (offsetDias: number) => {
  const fecha = new Date();
  fecha.setDate(fecha.getDate() + offsetDias);
  return fecha.toISOString().slice(0, 10);
};

export const abreviarIdentificador = (valor?: string | number | null, limite = 12) => {
  if (valor === undefined || valor === null) return "Sin referencia";
  const texto = String(valor);
  if (texto.length <= limite) return texto;
  return `${texto.slice(0, limite)}…`;
};

export const formatCurrencyGs = (valor?: number | null) => {
  const numero = Number(valor ?? 0);
  if (Number.isNaN(numero)) {
    return "Gs 0";
  }
  return `Gs ${numero.toLocaleString("es-PY")}`;
};

export const formatFechaHoraTexto = (
  valor?: string | null,
  options: Intl.DateTimeFormatOptions = { dateStyle: "short", timeStyle: "short" },
) => {
  if (!valor) return null;
  const fecha = new Date(valor);
  if (Number.isNaN(fecha.getTime())) {
    return valor;
  }
  return fecha.toLocaleString("es-PY", options);
};

export const construirNombreCajero = (nombre?: string | null, apellido?: string | null) => {
  if (!nombre && !apellido) return "Sin dato";
  return [nombre, apellido].filter(Boolean).join(" ");
};

export const normalizarFechaClave = (valor?: string | null) => {
  if (!valor) return null;
  const isoMatch = valor.match(/^\d{4}-\d{2}-\d{2}$/);
  if (isoMatch) {
    return valor;
  }
  const fecha = new Date(valor);
  if (Number.isNaN(fecha.getTime())) {
    return null;
  }
  return fecha.toISOString().slice(0, 10);
};

export const formatearFechaResumen = (clave: string | null) => {
  if (!clave) return "Sin fecha";
  const match = clave.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) {
    return clave;
  }
  const [, anho, mes, dia] = match;
  return `${dia}/${mes}/${anho}`;
};

export const normalizarPendiente = (
  item: CoincidenciaPendiente,
  index: number,
  tipo: "sistema" | "monchis",
): RegistroPendienteConciliacion => ({
  id: item.id ?? `${tipo}-${index}`,
  registroId: item.registroId,
  registroIdsucursal: item.registroIdsucursal,
  movimientoId: item.movimientoId,
  fecha: item.fecha,
  sucursal: item.sucursal ?? item.registroSucursalNombre ?? item.movimientoSucursal,
  movimientoSucursal: item.movimientoSucursal,
  monto:
    typeof item.monto === "number" ? item.monto : item.monto ? Number(item.monto) : null,
  formaPago: item.formaPago ?? item.movimientoTipoPago,
  observacion: item.observacion ?? item.detalle,
  tipo,
  registroTurno: item.registroTurno,
  registroNumeroMovimiento: item.registroNumeroMovimiento,
  movimientoTipoPago: item.movimientoTipoPago,
  movimientoNroTransaccion: item.movimientoNroTransaccion,
  movimientoNroOrden: item.movimientoNroOrden,
  movimientoEstado: item.movimientoEstado,
  movimientoTipoEntrega: item.movimientoTipoEntrega,
  movimientoFechaHora: item.movimientoFechaHora,
});

export const agruparPorSucursal = <T extends { registroIdsucursal?: number | null }>(
  lista: T[],
) => {
  const mapa = new Map<number, T[]>();
  lista.forEach((item) => {
    const clave = item.registroIdsucursal ?? 0;
    if (!mapa.has(clave)) {
      mapa.set(clave, []);
    }
    mapa.get(clave)!.push(item);
  });
  return mapa;
};

export const enriquecerCoincidencia = (fila: CoincidenciaAutomatica): CoincidenciaAutomatica => {
  const registroFechaTexto = formatFechaHoraTexto(fila.registroFechaDia, { dateStyle: "long" });
  const registroInicioTurnoTexto = formatFechaHoraTexto(fila.registroFechaHoraAperturaTurno, {
    dateStyle: "short",
    timeStyle: "short",
  });
  const registroFinTurnoTexto = formatFechaHoraTexto(fila.registroFechaCierre, {
    dateStyle: "short",
    timeStyle: "short",
  });
  return {
    ...fila,
    registroFechaTexto: registroFechaTexto ?? fila.registroFechaDia,
    registroInicioTurnoTexto: registroInicioTurnoTexto ?? fila.registroFechaHoraAperturaTurno,
    registroFinTurnoTexto: registroFinTurnoTexto ?? fila.registroFechaCierre,
  };
};

export const enriquecerCoincidencias = (lista: CoincidenciaAutomatica[]) =>
  lista.map(enriquecerCoincidencia);

export const describirOrigenConciliacion = (origen?: string | null) => {
  switch (origen) {
    case "automatica":
      return 'desde el botón "Guardar coincidencias" de BaconApp';
    case "sugerida":
      return "desde la sugerencia para revisión manual";
    case "manual":
      return "por conciliación manual aprobada";
    case "manual_reabierta":
      return "liberada manualmente para revisión";
    default:
      return "sin información de origen";
  }
};
